import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
export interface Tool {
  name: string;
  followers: string;
  description: string;
  icon: React.ReactNode;
  iconBgColor?: string;
  url: string;
  isVerified?: boolean;
}
export const VerifiedIcon = () => {
  const {
    theme
  } = useTheme();
  const fillColor = theme === 'dark' ? 'rgba(255, 255, 255, 0.75)' : 'rgba(0, 0, 0, 0.75)';
  return <svg width="14.4" height="16" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1 flex-shrink-0" aria-label="Verified company" title="Verified company" role="img" data-id="element-130">
      <title data-id="element-131">Verified company</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5 9C15.5 12.79 13.21 15.76 9.41 17.21L9.01 17.35L8.63 17.21C4.8 15.76 2.5 12.78 2.5 9V4.8L9 2.63L15.5 4.8V9ZM9.01 0L0 3V9C0 14 3.12 17.81 7.77 19.56L9 20L10.27 19.56C14.9 17.81 18.01 14 18.01 9V3L9.02 0H9.01ZM7.39 10.63L11.11 6H14.32L8.47 13.28L7.6 14.37L6.61 13.38L3.65 10.41L5.42 8.64L7.4 10.62L7.39 10.63Z" fill={fillColor} data-id="element-132" />
    </svg>;
};
export const careerCoachingTools: Tool[] = [{
  name: 'LinkedIn Interview Prep',
  followers: '33M+',
  description: 'Nail your next interview with AI-powered interview prep.',
  icon: <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" className="text-[#0A66C2] dark:text-[#ffffffe6]" data-id="element-133">
        <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" data-id="element-134"></path>
      </svg>,
  iconBgColor: '#e8f0fa',
  url: 'https://linkedin.com/showcase/linkedin-interview-prep-ai/about/',
  isVerified: true
}, {
  name: 'Microsoft Copilot',
  followers: '142K+',
  description: 'Land the job faster with draft resumes and interview prep.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vCmYXdA3oKpwh9UrKC1tjS/Microsoft_Copilot.png" alt="Microsoft Copilot logo" className="w-10 h-10 object-contain" style={{
    imageRendering: 'crisp-edges'
  }} data-id="element-135" />,
  iconBgColor: '#f0f5ff',
  url: 'https://linkedin.com/showcase/microsoftcopilot/product/',
  isVerified: true
}, {
  name: 'Kickresume',
  followers: '40K+',
  description: 'Land your dream job with an advanced AI career assistant.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tnX5i2U1bVSS1BsHaM4Whk/KickResume.svg" alt="Kick Resume logo" className="w-full h-full" data-id="element-136" />,
  iconBgColor: '#fff1f1',
  url: 'https://linkedin.com/company/kickresume-com/products/',
  isVerified: true
}, {
  name: 'Exponent Interview Prep',
  followers: '25K+',
  description: 'Practice for tech interviews with AI, courses, and community',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Fhtr5T7NNfXYCHDe22Daw/Exponent.svg" alt="Exponent logo" className="w-full h-full" data-id="element-137" />,
  iconBgColor: '#f5f3ff',
  url: 'https://www.linkedin.com/company/tryexponent/products/',
  isVerified: true
}, {
  name: 'Rezi',
  followers: '16K+',
  description: "The world's favorite AI Resume Builder.",
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ne3DRBxA4BZaGXhvXRrKcY/Rezi_AI.svg" alt="Rezi logo" className="w-full h-full dark:invert dark:brightness-90 dark:hue-rotate-180" data-id="element-138" />,
  iconBgColor: '#f5f3ff',
  url: 'https://linkedin.com/company/reziresume/product/',
  isVerified: true
}, {
  name: 'Yoodli',
  followers: '14K+',
  description: 'Private, real-time, and judgment-free AI roleplay coaching.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aQYMCsWKMDKHgxijAWw3Wc/Yoodli_AI.svg" alt="Yoodli AI logo" className="w-full h-full" data-id="element-139" />,
  iconBgColor: '#eef2ff',
  url: 'https://linkedin.com/company/yoodli/product/',
  isVerified: true
}, {
  name: 'LinkedIn Learning AI-powered Coaching',
  followers: '33M+',
  description: 'Get expert career guidance instantly with AI coaching.',
  icon: <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" className="text-[#0A66C2] dark:text-[#ffffffe6]" data-id="element-140">
        <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" data-id="element-141"></path>
      </svg>,
  iconBgColor: '#e8f0fa',
  url: 'https://linkedin.com/showcase/linkedin-learning-ai-powered-coaching/about/',
  isVerified: true
}];
export const marketingDesignTools: Tool[] = [{
  name: 'Adobe Express',
  followers: '15K+',
  description: 'The quick and easy app for creating on-brand content.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3qXugfshyzDbARTjMmV6ma/Adobe_Express.svg" alt="Adobe Express logo" className="w-full h-full" data-id="element-142" />,
  iconBgColor: '#f9f0ff',
  url: 'https://linkedin.com/showcase/adobe-express/',
  isVerified: true
}, {
  name: 'Canva',
  followers: '2M+',
  description: 'The AI-powered visual communication platform.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vttriEKW4q1KMJJEDkWMff/Canva.svg" alt="Canva Magic Design logo" className="w-full h-full" data-id="element-143" />,
  iconBgColor: '#e6fffa',
  url: 'https://linkedin.com/company/canva/product/',
  isVerified: true
}, {
  name: 'Figma',
  followers: '2M+',
  description: 'Make your ideas real with AI. Start with a design and prompt your way to a functional prototype, fast.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nLQyhyuqp1TVDXMydc1XzL/Figma_AI.svg" alt="Figma AI logo" className="w-full h-full" data-id="element-144" />,
  iconBgColor: '#fff1f2',
  url: 'https://linkedin.com/company/figma/product/',
  isVerified: true
}, {
  name: 'SemRush',
  followers: '576K+',
  description: 'Scaling digital marketing and growth for market-leaders.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qMCuB9qHkibN12gJW7qtA1/SemRush.svg" alt="SemRush logo" className="w-full h-full" data-id="element-145" />,
  iconBgColor: '#fff7ed',
  url: 'https://linkedin.com/company/semrush/products/',
  isVerified: true
}, {
  name: 'Hootsuite',
  followers: '533K+',
  description: 'The first-ever AI assistant for social media professionals.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rdNB9T1A8qmQvDEHUaNbjh/Hootsuite.svg" alt="Hootsuite Owly logo" className="w-full h-full" data-id="element-146" />,
  iconBgColor: '#fff1f1',
  url: 'https://linkedin.com/company/hootsuite/products/',
  isVerified: true
}, {
  name: 'Wix',
  followers: '368K+',
  description: 'Create a unique, business-ready website by talking with AI.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hJfF53ay3SuM9z4byjxnHC/Wix.svg" alt="Wix logo" className="w-full h-full dark:invert dark:brightness-90" data-id="element-147" />,
  iconBgColor: '#eff6ff',
  url: 'https://linkedin.com/company/wix-com/product/',
  isVerified: true
}, {
  name: 'WebflowAI',
  followers: '267K+',
  description: "Bring your vision to life with Webflow's AI site builder.",
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xkjivBeYtk8jzKLfu4YbAb/Webflow.svg" alt="Webflow AI logo" className="w-full h-full" data-id="element-148" />,
  iconBgColor: '#eff6ff',
  url: 'https://linkedin.com/company/webflow-inc-/product/',
  isVerified: true
}, {
  name: 'NewsWhip AI by Sprout',
  followers: '17K+',
  description: "The world's first real-time media monitoring agent.",
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nAneFYNh9hc5Y95TtyWVeB/Newswhip.svg" alt="Newswhip AI logo" className="w-full h-full" data-id="element-149" />,
  iconBgColor: '#fdf2f8',
  url: 'https://linkedin.com/company/newswhip-media/products/',
  isVerified: true
}, {
  name: 'Squarespace',
  followers: '150K+',
  description: 'Create a personalized website in minutes with AI.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/728rwsYFqawKehUXAAHhEj/Squarespace.svg" alt="Squarespace logo" className="w-full h-full dark:invert dark:brightness-90" data-id="element-150" />,
  iconBgColor: '#f8fafc',
  url: 'https://linkedin.com/company/squarespace/product/',
  isVerified: true
}, {
  name: 'Typeface',
  followers: '62K+',
  description: 'The agentic AI platform designed for enterprise marketers.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8MR7PySvuzXzyBoKqjj1rT/Typeface.svg" alt="Typeface logo" className="w-full h-full" data-id="element-151" />,
  iconBgColor: '#fef2f2',
  url: 'https://linkedin.com/company/typefaceai/products/',
  isVerified: true
}, {
  name: 'Leonardo AI',
  followers: '45K+',
  description: 'Powerful AI content suite where everyone is a creator.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uM1StHaXwU4Cc6wCv6bNdK/Leonardo.ai.svg" alt="Leonardo.AI logo" className="w-full h-full" data-id="element-152" />,
  iconBgColor: '#ecfdf5',
  url: 'https://linkedin.com/company/leonardo-ai/product/',
  isVerified: true
}, {
  name: 'Descript',
  followers: '30K+',
  description: 'If you can edit text, you can make video with Descript.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mAyRajuygEKk7Dg6e1tbvv/Descript.svg" alt="Descript logo" className="w-full h-full" data-id="element-153" />,
  iconBgColor: '#eff6ff',
  url: 'https://linkedin.com/company/descript/product/',
  isVerified: true
}, {
  name: 'Opus Clip',
  followers: '24K+',
  description: 'Video clipping tool that turns long video into viral shorts.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gGdZv1676Q1enirqjUuEJb/Opus_Clip.svg" alt="Opus Clip logo" className="w-full h-full dark:invert dark:brightness-90" data-id="element-154" />,
  iconBgColor: '#f8fafc',
  url: 'https://linkedin.com/company/opusclip/products/',
  isVerified: true
}, {
  name: 'Mirage',
  followers: '16K+',
  description: 'Generate and edit short-form video with expressive AI actors.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bTwMXyzvyyZA5c9uYeDKBn/Mirage.svg" alt="Mirage logo" className="w-full h-full" data-id="element-155" />,
  iconBgColor: '#fffbeb',
  url: 'https://linkedin.com/company/trymirage/products/',
  isVerified: true
}, {
  name: 'Surfer',
  followers: '14K+',
  description: 'Helping brands win visibility across Google and AI search.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bTynKUhyAwdFSyK73MRT2j/Surfer_AI.svg" alt="Surfer AI logo" className="w-full h-full" data-id="element-156" />,
  iconBgColor: '#fff1f2',
  url: 'https://linkedin.com/company/surfer/products/',
  isVerified: true
}, {
  name: 'Creatify',
  followers: '10K+',
  description: 'One platform to create, test, and launch AI video ads.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nJqvNqrqKShT3RMeC8i1yk/Creatify.svg" alt="Creatify AI logo" className="w-full h-full" data-id="element-157" />,
  iconBgColor: '#f5f3ff',
  url: 'https://linkedin.com/company/creatify-ai/products/',
  isVerified: true
}, {
  name: 'Typetone.ai',
  followers: '3K+',
  description: '100% authentic and automated SEO and social media.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m8oNYKsvR8k4uHXvKwSKFH/Typetone.svg" alt="Typetone.ai logo" className="w-full h-full dark:invert dark:brightness-90" data-id="element-158" />,
  iconBgColor: '#f8fafc',
  url: 'https://linkedin.com/company/typetone/products/',
  isVerified: true
}];
export const codingAppDevelopmentTools: Tool[] = [{
  name: 'GitHub Copilot',
  followers: '6M+',
  description: 'AI developer platform to build, scale, and deliver software.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Pkx6EbAaWV3WLwW5vVFjo/GitHub_Copilot.svg" alt="GitHub Copilot logo" className="w-full h-full" data-id="element-159" />,
  iconBgColor: '#e6f6ff',
  url: 'https://linkedin.com/company/github/product/',
  isVerified: true
}, {
  name: 'Replit',
  followers: '130K+',
  description: 'Create beautiful, modern web apps with the power of AI.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d8c4VMRemFNWY7Mr9ThtYD/Replit.svg" alt="Replit logo" className="w-full h-full" data-id="element-160" />,
  iconBgColor: '#fff7ed',
  url: 'https://linkedin.com/company/repl-it/products/',
  isVerified: true
}, {
  name: 'Windsurf / Codeium',
  followers: '59K+',
  description: 'Empower developers with an AI-collaborative environment.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/usYT3V9eAcghJA3XtTpj7B/Windsurf.svg" alt="Windsurf logo" className="w-full h-full dark:invert dark:brightness-90" data-id="element-161" />,
  iconBgColor: '#e0f2fe',
  url: 'https://linkedin.com/company/windsurf/products/',
  isVerified: true
}, {
  name: 'Lovable',
  followers: '353K+',
  description: 'Build apps and websites by chatting with AI.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4txbCHFxVFu78fWDXiQgzV/Lovable.svg" alt="Lovable logo" className="w-full h-full" data-id="element-162" />,
  iconBgColor: '#fff1f2',
  url: 'https://linkedin.com/company/lovable-dev/product/',
  isVerified: true
}, {
  name: 'Magic Patterns',
  followers: '10K+',
  description: 'AI design tool to create interactive prototypes and websites.',
  icon: <img src="https://magicpatterns-assets.s3.us-west-1.amazonaws.com/marketing/logos/MP-Logo.svg" alt="Magic Patterns logo" className="w-full h-full" data-id="element-163" />,
  iconBgColor: '#ffefef',
  url: 'https://linkedin.com/company/magicpatterns/product/',
  isVerified: true
}, {
  name: 'Subframe',
  followers: '5K+',
  description: 'Design interfaces with AI and ship pixel-perfect code.',
  icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hAytS8J5d28bSHyqwy9vUR/Subframe.png" alt="SubFrame logo" className="w-full h-full" data-id="element-164" />,
  iconBgColor: '#f8fafc',
  url: 'https://linkedin.com/company/subframeapp/product/',
  isVerified: true
}];